import {g as getDefaultExportFromCjs, c as createCommonjsModule} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {P as Popper$1} from "./Popper-131a89f2.js";
var Popper = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Popper.default;
    }
  });
  var _Popper = interopRequireDefault(Popper$1);
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Popper);
export {Popper as P, __pika_web_default_export_for_treeshaking__ as _};
